<template>
    <section :id="slice.primary.anchorName || undefined" class="slice slice-features slice-features--centred" aria-label="features">
        <div class="slice-content">
            <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" />
            <PrismicRichText v-if="slice.primary.description" :field="slice.primary.description" class="slice-description" />
            <div class="slice-features--centred__items">
                <div v-for="(item, i) in slice.items" :key="i" class="slice-features--centred__item">
                    <PrismicImage :field="item.image" class="slice-features--centred__item-image" />
                    <div class="slice-features--centred__item-content">
                        <div class="slice-features--centred__item-title">{{ item.title }}</div>
                        <PrismicRichText :field="item.text" class="slice-features--centred__item-text" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicImage, PrismicRichText} from '@prismicio/vue';
    import type {FeaturesSlice} from '@prismicio-types';

    type FeaturesCentredInZone = Extract<FeaturesSlice, {variation: 'featuresCentred'}>;
    defineProps(getSliceComponentProps<FeaturesCentredInZone>());
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-features--centred {
        &__items {
            display: flex;
            flex-wrap: wrap;
            text-align: left;
            margin-top: var(--joy-core-spacing-10);
        }

        &__item {
            display: flex;
            align-items: flex-start;
            margin-bottom: var(--joy-core-spacing-8);
            gap: var(--joy-core-spacing-4);

            @include mq.screen_md(min) {
                width: 50%;
                gap: var(--joy-core-spacing-5);

                &:nth-child(odd) {
                    padding-right: var(--joy-core-spacing-8);
                }
            }

            &-image {
                flex: none;
                width: 64px;

                @include mq.screen_md(min) {
                    width: 96px;
                }
            }

            &-content {
                flex: 1 1 0%;
            }

            &-title {
                font-family: var(--joy-font-family-title);
                font-size: var(--joy-font-size-primary-600);
                color: var(--joy-color-neutral-60);
                margin-bottom: var(--joy-core-spacing-2);

                @include mq.screen_md(min) {
                    font-size: var(--joy-font-size-secondary-200);
                }
            }
        }
    }
</style>
